import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslate } from 'src/locales';
import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function ButtonLoadMore(t0) {
  const $ = _c(30);
  let loading;
  let other;
  let showing;
  let sx;
  let t1;
  let t2;
  let total;
  if ($[0] !== t0) {
    ({
      sx,
      total,
      showing,
      loading,
      perPage: t1,
      otherCondition: t2,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = loading;
    $[2] = other;
    $[3] = showing;
    $[4] = sx;
    $[5] = t1;
    $[6] = t2;
    $[7] = total;
  } else {
    loading = $[1];
    other = $[2];
    showing = $[3];
    sx = $[4];
    t1 = $[5];
    t2 = $[6];
    total = $[7];
  }
  const perPage = t1 === undefined ? 20 : t1;
  const otherCondition = t2 === undefined ? true : t2;
  const {
    t
  } = useTranslate();
  if (!(total > showing && showing >= perPage && otherCondition)) {
    return null;
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "grid",
      placeItems: "center"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== sx) {
    t4 = Array.isArray(sx) ? sx : [sx];
    $[9] = sx;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = [t3, ...t4];
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== loading) {
    t6 = !loading && <Iconify icon="eva:arrow-ios-downward-fill" width={24} />;
    $[13] = loading;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== loading) {
    t7 = loading && <Iconify icon="svg-spinners:12-dots-scale-rotate" width={24} />;
    $[15] = loading;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: {
        xs: 1,
        md: 320
      }
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = loading ? "Loading..." : "Show more";
  let t10;
  if ($[18] !== t || $[19] !== t9) {
    t10 = t(t9);
    $[18] = t;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== loading || $[22] !== other || $[23] !== t10 || $[24] !== t6 || $[25] !== t7) {
    t11 = <Button size="large" disabled={loading} variant="outlined" endIcon={t6} startIcon={t7} sx={t8} {...other}>{t10}</Button>;
    $[21] = loading;
    $[22] = other;
    $[23] = t10;
    $[24] = t6;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t5) {
    t12 = <Box sx={t5}>{t11}</Box>;
    $[27] = t11;
    $[28] = t5;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}